module.exports = __webpack_public_path__ + "static/media/group.c1a7828b.png";